<template> 
  <div class="wrap-Outer" v-show="isShowPage">
	<div v-wechat-title="companyBriefName"></div>
    <div class="headerBox">
      <div class="img-swiper" v-if="banner&&banner.items&&banner.items.length>1">
        <swiper :options="swiperOption" style="width:100%;height:100%;">
          <swiper-slide v-for="(item,index) in banner.items" :key="index">
            <img :src="item.imgUrl" alt />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="single-img" v-else>
        <img :src="banner&&banner.items&&banner.items.length>0&&banner.items[0].imgUrl" alt />
      </div>
    </div>
	
	<div class="boxBody" v-if="companyBrief=='jxlife'">
		<!-- 专栏部分 -->
		  <div class="SpecialColumn" v-if="homeData.twoModule">
		    <div class="twoTab flex flex-wrap flex-between">
		      <div
		        class="twoTab_item"
		        v-for="(item,index) in homeData.twoModule.items"
		        :key="index"
		        :style="{backgroundImage:'url('+item.imgUrl +')'}"
		        :class="{twoTab_right:index%2!=0,twoTab_left:index%2==0}">
		        <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
		          class="link-a" @click="handleToRealName(item)">
		          <div class="twoTab_item_container">
		            <!-- 文本对齐div -->
		            <div class="layoutLine">
		              <div class="title">
		                <span>{{item.itemName}}</span>
		              </div>
		              <div class="info">
		                <span>{{item.itemDesc}}</span>
		              </div>
		              <div class="specialInfo">
		                <span v-if="index%2!=0">急速</span>
						<span v-else>热门</span>
		              </div>
		            </div>
		          </div>
		        </a>
		      </div>
		    </div>		
		  </div>
		  
		  <div class="medical_service" v-if="homeData.zjtd">
		    <div class="serve_title">
		      <div class="title fl">
		        <span>{{homeData.zjtd.channelName}}</span>
		      </div>		      
		    </div>		
		    <div class="serve_body">
		      <div class="serve_body_container flex">
		        <!-- 左边部分 -->
		        <div class="leftBox itemBox"
		          v-for="(item,index) in homeData.zjtd.items"
		          :key="index"
		          :class="{'leftBox':index%2==0,
		          'rightBox':index%2!=0 }">
		          <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
		            class="link-a" @click="handleToRealName(item)">
		            <!-- 居中容器部分 -->
		            <div class="containerCenter flex">
		              <div class="imgbox">
		                <img :src="item.imgUrl" alt />
		              </div>
		              <div class="infoBox">
		                <div class="infoBox_top">
		                  <span>{{item.itemName}}</span>
		                </div>
		                <div class="infoBox_bottom">
		                  <span>{{item.itemDesc}}</span>
		                </div>
		              </div>
		            </div>
		          </a>
		        </div>
		      </div>
		    </div>
		  </div>
		  <div class="medical_service" v-if="homeData.sywz">
		    <div class="serve_title">
		      <div class="title fl">
		        <span>{{homeData.sywz.channelName}}</span>
		      </div>		      
		    </div>		
		    <div class="serve_body">
		      <div class="serve_body_container flex">
		        <!-- 左边部分 -->
		        <div class="leftBox itemBox"
		          v-for="(item,index) in homeData.sywz.items"
		          :key="index"
		          :class="{'leftBox':index%2==0,
		          'rightBox':index%2!=0 }">
		          <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
		            class="link-a" @click="handleToRealName(item)">
		            <!-- 居中容器部分 -->
		            <div class="containerCenter flex">
		              <div class="imgbox">
		                <img :src="item.imgUrl" alt />
		              </div>
		              <div class="infoBox">
		                <div class="infoBox_top">
		                  <span>{{item.itemName}}</span>
		                </div>
		                <div class="infoBox_bottom">
		                  <span>{{item.itemDesc}}</span>
		                </div>
		              </div>
		            </div>
		          </a>
		        </div>
		      </div>
		    </div>
		  </div>
		  <div class="medical_service" v-if="homeData.jkzx">
		    <div class="serve_title">
		      <div class="title fl">
		        <span>{{homeData.jkzx.channelName}}</span>
		      </div>		      
		    </div>		
		    <div class="serve_body">
		      <div class="serve_body_container flex">
		        <!-- 左边部分 -->
		        <div class="item3"
		          v-for="(item,index) in homeData.jkzx.items"
		          :key="index">
		          <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
		            class="link-a" @click="handleToRealName(item)">
		            <!-- 居中容器部分 -->
		            <div class="item3Content">
		              <img :src="item.imgUrl" alt />
		              <div class="text">
		                {{item.itemName}}
		              </div>
		            </div>
		          </a>
		        </div>
		      </div>
		    </div>
		  </div>
		  <div class="medical_service" v-if="homeData.jkpg">
		    <div class="serve_title">
		      <div class="title fl">
		        <span>{{homeData.jkpg.channelName}}</span>
		      </div>		      
		    </div>		
		    <div class="serve_body">
		      <div class="serve_body_container flex">
		        <!-- 左边部分 -->
		        <div class="item3"
		          v-for="(item,index) in homeData.jkpg.items"
		          :key="index">
		          <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
		            class="link-a" @click="handleToRealName(item)">
		            <!-- 居中容器部分 -->
		            <div class="item3Content">
		              <img :src="item.imgUrl" alt />		              
		              <div class="text">
		                {{item.itemName}}
		              </div>
		            </div>
		          </a>
		        </div>
		      </div>
		    </div>
		  </div>
		  <div class="medical_service" v-if="homeData.jksh">
		    <div class="serve_title">
		      <div class="title fl">
		        <span>{{homeData.jksh.channelName}}</span>
		      </div>		      
		    </div>		
		    <div class="serve_body">
		      <div class="serve_body_container flex">
		        <!-- 左边部分 -->
		        <div class="leftBox itemBox"
		          v-for="(item,index) in homeData.jksh.items"
		          :key="index"
		          :class="{'leftBox':index%2==0,
		          'rightBox':index%2!=0 }">
		          <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
		            class="link-a" @click="handleToRealName(item)">
		            <!-- 居中容器部分 -->
		            <div class="containerCenter flex">
		              <div class="imgbox">
		                <img :src="item.imgUrl" alt />
		              </div>
		              <div class="infoBox">
		                <div class="infoBox_top">
		                  <span>{{item.itemName}}</span>
		                </div>
		                <div class="infoBox_bottom">
		                  <span>{{item.itemDesc}}</span>
		                </div>
		              </div>
		            </div>
		          </a>
		        </div>
		      </div>
		    </div>
		  </div>
		  <div class="medical_service" v-if="homeData.ylfw">
		    <div class="serve_title">
		      <div class="title fl">
		        <span>{{homeData.ylfw.channelName}}</span>
		      </div>		      
		    </div>		
		    <div class="serve_body">
		      <div class="serve_body_container flex">
		        <!-- 左边部分 -->
		        <div class="leftBox itemBox"
		          v-for="(item,index) in homeData.ylfw.items"
		          :key="index"
		          :class="{'leftBox':index%2==0,
		          'rightBox':index%2!=0 }">
		          <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
		            class="link-a" @click="handleToRealName(item)">
		            <!-- 居中容器部分 -->
		            <div class="containerCenter flex">
		              <div class="imgbox">
		                <img :src="item.imgUrl" alt />
		              </div>
		              <div class="infoBox">
		                <div class="infoBox_top">
		                  <span>{{item.itemName}}</span>
		                </div>
		                <div class="infoBox_bottom">
		                  <span>{{item.itemDesc}}</span>
		                </div>
		              </div>
		            </div>
		          </a>
		        </div>
		      </div>
		    </div>
		  </div>
	</div>	
    <!-- box 版心主体部分  -->
    <div class="boxBody" v-else>
      <!-- 专栏部分 -->
      <div class="SpecialColumn" v-if="twoModule&&twoModule.items&&twoModule.items.length>1">
        <div class="twoTab flex flex-wrap flex-between">
          <div
            class="twoTab_item"
            v-for="(item,index) in twoModule.items"
            :key="index"
            :style="{backgroundImage:'url('+item.imgUrl +')'}"
            :class="{twoTab_right:index%2!=0,twoTab_left:index%2==0}">
            <a :href="item.needRealName==1?'javascript:;':item.linksUrl"
              class="link-a" @click="handleToRealName(item)">
              <div class="twoTab_item_container">
                <!-- 文本对齐div -->
                <div class="layoutLine">
                  <div class="title">
                    <span>{{item.itemName}}</span>
                  </div>
                  <div class="info">
                    <span>{{item.itemDesc}}</span>
                  </div>
                  <div class="specialInfo">
                    <span>急速</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div class="topTab_BOX flex flex-wrap">
          <!-- swiper-wrapper -->
         <swiper :options="swiperOption" v-if="fourModule&&fourModule.items&&fourModule.items.length>1">
           
            <swiper-slide  class="topTab_BOX_item swiper-slide" v-for="(item,index) in fourModule.items" :key="index">
              <a
                :href="item.needRealName==1?'javascript:;':item.linksUrl"
                class="link-a"
                @click="handleToRealName(item)">
                <div
                  class="box_img"
                  :class="{'TelephoneDoctor':index=='0','ReportRead':index=='1','Registeradvance':index=='2','more':index=='3'}"
                >
                  <img :src="item.imgUrl" alt />
                </div>
                <div class="box_txt">
                  <span>{{item.itemName}}</span>
                </div>
              </a>
              
            </swiper-slide>
            <div  class="swiper-pagination" slot="pagination"></div>
            
    <!-- Add Arrows -->

          </swiper>
        </div>
      </div>
      <div class="medical_service" v-if="green">
        <div class="serve_title">
          <div class="title fl">
            <span>{{green.channelName}}</span>
          </div>
          <div class="networkService_txt fr" @click="fwwlLink(fwwl)" >
            <!-- {{fwwl}} -->
            <span class="linkTxt">{{fwwl.channelName}}</span>
          </div>
        </div>

        <div class="serve_body">
          <div class="serve_body_container flex" v-if="green&&green.items&&green.items.length>1">
            <!-- 左边部分 -->
            <div
              class="leftBox itemBox"
              v-for="(item,index) in green.items"
              :key="index"
              :class="{'leftBox':index%2==0,
              'rightBox':index%2!=0 }"
            >
              <a
                :href="item.needRealName==1?'javascript:;':item.linksUrl"
                class="link-a"
                @click="handleToRealName(item)"
              >
                <!-- 居中容器部分 -->
                <div class="containerCenter flex">
                  <div class="imgbox">
                    <img :src="item.imgUrl" alt />
                  </div>
                  <div class="infoBox">
                    <div class="infoBox_top">
                      <span>{{item.itemName}}</span>
                    </div>
                    <div class="infoBox_bottom">
                      <span>{{item.itemDesc}}</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- 特色服务div -->
      <div class="healthyInfo" v-if="special&&special.items&&special.items.length>1">
        <!-- 特色服务文字部分start -->
        <div class="healthyInfoTitle">
          <div class="txt">
            <span>{{special.channelName}}</span>
          </div>
        </div>

        <!-- 特色服务文字部分end -->
        <div class="healthyInfo_item" v-for="(item,index) in special.items" :key="index">
          <!-- 中间item容器 居中部分start -->
          <a
            :href="item.needRealName==1?'javascript:;':item.linksUrl"
            class="link-a"
            @click="handleToRealName(item)"
          >
          
            <div class="item_container flex">
              <!-- 图片区域 -->
              <div class="healthyImg_box">
                <img :src="item.imgUrl" alt />
              </div>
              <!-- 信息描述区域 start -->
              <div class="healthyInfo_box">
                <!-- 信息描述区域 中间居中容器 start -->
                <div class="container_Info">
                  <!-- 上面信息部分 -->
                  <div class="h_top">
                    <p>{{item.itemName}}</p>
                  </div>
                  <!-- 下面信息部分 -->
                  <div class="h_bottom">
                    <span>{{item.itemDesc}}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <!-- 特色服务 div  end-->
    </div>
    <!-- box 版心主体部分 end -->
    <!-- 底部导航 -->
    <div class="bottomTab">
      <div @click="hometab" class="bottomTab_item item_home">
        <div class="item_Container">
          <div class="item_img">
            <img src="../assets/image/tab/homeTab_yes.png" alt />
          </div>
          <div class="item_txt home_txt">
            <span>首页</span>
          </div>
        </div>
      </div>
      <div @click="healthCard" class="bottomTab_item item_healthy">
        <div class="item_Container">
          <div class="item_img">
            <img src="../assets/image/tab/healthCard_no.png" alt />
          </div>
          <div class="item_txt txt_healthCard">
            <span>健康卡</span>
          </div>
        </div>
      </div>
      <div @click="myTab" class="bottomTab_item item_my">
        <div class="item_Container">
          <div class="item_img">
            <img src="../assets/image/tab/myTab_no.png" alt />
          </div>
          <div class="item_txt txt_my">
            <span>个人中心</span>
          </div>
        </div>
      </div>
    </div>
    <alert-box-item :paramObj="paramObj" @handle-cert="handleCert"></alert-box-item>
  </div>
</template>

<script>
import AlertBox from "../components/alert-box";
import { getApi, postApi } from "../api/index.js";
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import {AppIdName,TokenName,jxAppId} from '../api/api.js';

export default {
  components: {
    "alert-box-item": AlertBox,
    swiper,
	    swiperSlide
  },
  data() {
    return {
      // 轮播
      swiperOption: {
        slidesPerView:4,
        spaceBetween:25,
        slidesPerGroup:4,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true // 允许点击小圆点跳转
        },        
        paginationType: 'custom',
        autoplay: {
          delay: 3000,
          disableOnInteraction: false // 手动切换之后继续自动轮播
        },
        loop: true
      },
      isShowPage: false,
	  //轮播图
      banner: {},
	  //两个模块
      twoModule: {},
	  //四个模块
      fourModule: {},
	  //就医绿通
      green: {},
	  //特色服务
      special: {},
	  //服务网络
      fwwl:{},
	  
	  //公众号简称
	  companyBrief:'',
      openId: "",
      code: "",  
	  //首页的数据
	  homeData:{},
      paramObj: {},
      lifeToken: "",
	  appId:this.$route.query.appid,
	  companyBriefName:"企业健康管理"
    };
  },
  created: function() {    	 	
	if (!this.appId){
		this.appId = localStorage.getItem(AppIdName); 
	}	
	if (!this.appId){
		this.$toast("缺失appid参数");
		return;
	}		
	if (this.appId == jxAppId)
		this.companyBriefName = '吉祥医生健康管家';	
	localStorage.setItem(AppIdName,this.appId);  	
    this.lifeToken = localStorage.getItem(TokenName+this.appId || "");	
    if (this.lifeToken || this.appId == jxAppId) {
      this.gethomeData();
    } else {
      this.handleWx();
    }
  },
  methods: {
	// 服务网络跳转
	fwwlLink(item){
		  if (item.needRealName == 1) {
		  return  this.paramObj = {
			  isShow: true,
			  title: "提示",
			  content: "您还没有实名认证，现在就去完成实名认证。"
			};
		  }
	  else{
		location.href=this.fwwl.linksUrl;
	  }
	},
    //  底部导航切换
    hometab() {
      this.$router.push("/home?appid="+localStorage.getItem(AppIdName));
    },
    healthCard() {
	  if (!this.lifeToken && this.appId == jxAppId){
	    this.$router.push({
	      path: '/login',
	      query: {
	  	      isFrom: 1
	  	    }
	    })
	    return;
	  }
      this.$router.push("/system/healthCard?appid="+localStorage.getItem(AppIdName));
    },
    myTab() {
		if (!this.lifeToken && this.appId == jxAppId){
		  this.$router.push({
		    path: '/login',
		    query: {
			      isFrom: 1
			    }
		  })
		  return;
		}
		this.$router.push("/my?appid="+localStorage.getItem(AppIdName));
    },
    handleWx() {
      let code = this.$route.query.code;
      if (code && code != "") {
        this.code = code;
        this.toLogin();
      } else {
        this.onCheck();
      }
    },
    toLogin() {	  
      getApi({ url: "/member/login/" + this.code+"?appId="+this.appId, query: {} })
        .then(res => {
          if (res && res.resCode == "0") {
            if (res.data) {			  
              localStorage.setItem(TokenName+this.appId, res.data.accessToken);
              this.gethomeData();
            } else {
              this.$toast("登录失败");
            }
          } else {
            this.$toast(res.resMsg || "登录失败");
          }
        })
        .catch(res => {
          console.log("登录失败");
        });
    },

    onCheck() {
      let url = encodeURIComponent(window.location.href);      
      let weixinUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.appId + "&redirect_uri=" + url +
        "&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect";
      window.location.href = weixinUrl;
    },
	
    handleToRealName(item) {
      getApi({ url: "/home/viewItem/" + item.itemName, query: {} })
        .then(res => {})
        .catch(res => {});
	  if (!this.lifeToken && this.appId == jxAppId){
		  this.$router.push({
		    path: '/login',
		    query: {
		      isFrom: 2
		    }
		  })
		  return;
	  }
      if (item.needRealName == 1) {
        this.paramObj = {
          isShow: true,
          title: "提示",
          content: "您还没有实名认证，现在就去完成实名认证。"
        };
      }else{
		  window.location.href = item.linksUrl
	  }
    },
    handleCert() {
      this.$router.push({
        path: "/real",
        query: {
          isFrom: 1
        }
      });
    },
    gethomeData() {
      getApi({ url: "/home/info", query: {appId:this.appId} })
        .then(res => {
          if (res && res.resCode == "0") {
            if (res.data) {
              this.isShowPage = true;
			  this.companyBrief = res.data.companyBrief.channelName;			 
			  sessionStorage.setItem("publicCompanyBrief",this.companyBrief);
              this.banner = res.data.banner;
              this.twoModule = res.data.twoModule;
              this.fourModule = res.data.fourModule;
              this.green = res.data.green;
              this.special = res.data.special;
              this.fwwl=res.data.fwwl;
			  this.homeData = res.data;              
            } else {
              this.$toast("获取首页数据失败");
            }
          } else {
            this.$toast("获取首页数据失败");
          }
        })
        .catch(res => {
          console.log("获取首页数据失败");
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../common/css/style.css";
// @import '../assets/font/iconfont.css';
// 最外层 包裹  warp;

.swiper-container{
  padding-bottom: 0.2rem;
}
.swiper-pagination{
  position: absolute;
  margin-bottom: 0.2rem;
width: 100%;
top: 1.15rem;
}

.wrap-Outer {
  width: 100%;
  background-color: #ffffff;
}
// 头部标题 部分
.headerBox {
  width: 100%;
  overflow: hidden;
  padding-bottom: 0.3rem;
  background-color: #ffffff;
  // 图片div
  .img_box {
    width: 100%;
    height: 2.8rem;
  }
}
.img-swiper {
  img {
    width: 100%;
    height: 100%;
  }
}
.single-img {
  img {
    width: 100%;
    height: 100%;
  }
}
// box 版心
.boxBody {
  padding-right: 0.24rem;
  padding-left: 0.24rem;
  padding-bottom: 1.8rem;
}
// 专栏部分
.SpecialColumn {
  width: 100%;
}
// 健康专线 就医预约 专栏部分 整体
.twoTab {
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;
}
.link-a {
  width: 100%;
  height: 100%;
}
// 健康专线 就医预约 专栏部分 左右两边公共部分
.twoTab_item {
  width: 48%;
  height: 1.9rem;
  background-repeat: no-repeat;
  background-size: 100%;
  margin-bottom: 0.1rem;
}
.twoTab_item_container {
  width: 3.4rem;
  height: 1.9rem;
  // 文本对齐div
  .layoutLine {
    padding-left: 0.3rem;
    padding-top: 0.32rem;
    // 标题
    .title {
      font-size: 0.3rem;
      //font-weight: bold;
      color: #000000;
    }
    // 描述信息
    .info {
      margin-top: 0.03rem;
      color: #848a8c;
      font-size: 0.23rem;
    }
    // 描述特点
    .specialInfo {
      margin-top: 0.14rem;
      width: 0.68rem;
      height: 0.32rem;
      text-align: center;
      line-height: 0.32rem;
      border: 0.01rem #f77660 solid;
      // 左上角，右上角，右下角，左下角。
      border-radius: 0.03rem 0.16rem 0.16rem 0.11rem;
      color: #f77660;
      font-size: 0.19rem;
    }
  }
}

// 健康专线 就医预约 专栏部分 左边
.twoTab_left {
}

.twoTab_right {
}
// box 版心 顶部专栏;
.topTab_BOX {
  padding-bottom: 0.2rem;
  margin-top: 0.41rem;
  width: 100%;
  background-color: #ffffff;
  .topTab_BOX_item {
    width: 33.33%;
    margin-bottom: 0.1rem;
    .box_img {
      width: 0.9rem;
      height: 0.9rem;
      margin: 0 auto;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  // 图片div
  .box_img {
    width: 100%;
    height: 1rem;
  }
  // 文字div
  .box_txt {
    text-align: center;
    font-size: 0.26rem;
  }
}
// 就医绿通
.medical_service {
  overflow: hidden;
  width: 100%;
  background-color: #ffffff;
  margin-top: 0.25rem;
  border-radius: 0.2rem;
  box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.06);
  // 就医绿通 标题部分
  .serve_title {
    // 就医绿通
    .title {
      overflow: hidden;
      padding: 0.34rem 0 0.2rem 0.29rem;
      color: #202020;
      font-weight: bold;
      font-size: 0.30rem;
    }
    // 网络服务
    .networkService_txt {
      width: 1.55rem;
      height: 0.5rem;
      background: url("../assets/image/home/more03.png") no-repeat;
      background-position: 1.3rem 0.1rem;
      margin-top: 0.35rem;
      margin-right: 0.53rem;
      .linkTxt {
        color: rgb(102, 102, 102);
        font-size: 0.28rem;
      }
    }
  }
}
//  医疗服务 主体部分
.serve_body {
  padding-top: 0.3rem;
  width: 100%;
  // 子部分
  .serve_body_container:first-child {
    border-top: solid rgb(238, 238, 238) 0.01rem;
  }
  .serve_body_container {
    box-sizing: border-box;
    width: 100%;
    flex-wrap: wrap;
	
	.item3{
		width: 33%;
		display: flex;
		flex-direction: row;
		.item3Content{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding:0.2rem;
			img{
				width: 1rem;
				height: 1rem;
			}
			.text{				
				color: #000000;
				font-size: 0.3rem;
			}
		}
	}
    //子部分  左边部分
    .leftBox {
      width: 49.5%;
      border-bottom: solid rgb(238, 238, 238) 0.01rem;
    }
    //子部分  右边部分
    .rightBox {
      width: 49.5%;
      border-left: solid rgb(238, 238, 238) 0.01rem;
      border-bottom: solid rgb(238, 238, 238) 0.01rem;
    }
    .rightBox :last-child {
      border-bottom: solid transparent 0.01rem;
    }
    // 子部分 左右部分 共有 容器居中container
    .containerCenter {
      width: 100%;
      margin: 0.3rem auto;
    }
    // 子部分 左右部分 共有 容器居中container> 图片box
    .imgbox {
      width: 1rem;
      height: 1rem;
    }
    // 子部分 左右部分 共有 容器居中container> 左边信息部分
    .infoBox {
      padding-top: 0.1rem;
      // 上面文字部分
      .infoBox_top {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        color: rgb(0, 0, 0);
        font-size: 0.322rem;
      }
      // 下面文字部分
      .infoBox_bottom {
        overflow: hidden;
        white-space: nowrap;
        overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
        text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
        width: 100%;
        color: #878787;
        padding-top: 0.1rem;
        font-size: 0.241rem;
      }
    }
  }
}

// 每日健康 内容部分
.healthyInfo {
  margin-bottom: 0.8rem;
  overflow: hidden;
  border-radius: 0.2rem;
  width: 100%;
  background-color: #ffffff;
  .healthyInfoTitle {
    padding: 0.33rem 0 0.3rem 0.33rem;
    width: 100%;
    border-bottom: 0.01rem solid #f8f8f8;
    box-sizing: border-box;
    .txt {
      box-sizing: border-box;
      font-size: 0.34rem;
      //font-weight: bold;
    }
  }
  //  子盒子
  .healthyInfo_item {
    width: 100%;
    //  子盒子 container  居中部分
    .item_container {
      height: 1.4rem;
      padding-left: 0.2rem;
      padding-right: 0.2rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
    // 子盒子 左边 imgbox区域
    .healthyImg_box {
      box-sizing: border-box;
      width: 1.8rem;
      // height: 1.2rem;
      background-color: #a5a5a5;
      border-radius: 0.15rem;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 子盒子 右边 描述信息区域
    .healthyInfo_box {
      width: 4.8rem;
      margin-left: 0.2rem;
      border-bottom: #f6f6f6 solid 0.01rem;
      // 子盒子 右边>描述信息区域> container
      .container_Info {
        // 上面 部分
        .h_top {
          font-size: 0.32rem;
          font-weight: bold;
          color: rgb(0, 0, 0);
        }
        //  下面部分
        .h_bottom {
          // 多行文本溢出
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          /*两行文本*/
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 0.24rem;
          margin-top: 0.1rem;
          color: rgb(153, 153, 153);
        }
      }
    }
  }
}
.bottomTab {
  display: flex;
  width: 100%;
  background-color: #ffffff;
  position: fixed;
  left: 0;
  bottom: 0;
  .bottomTab_item {
    width: 33.33%;
    text-align: center;

	.item_Container {
      margin: 0 auto;
      .item_img {
        img {
          width: 0.6rem;
          height: 0.6rem;
        }
      }
      .home_txt {
        color: #1380e9;
      }
      .item_txt {
        padding-bottom: 0.05rem;
        font-size: 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>